import { GetServerSideProps, NextPage } from 'next';

import { PublishersContent } from '@/components/ui/features/societies/PublishersContent/PublishersContent';
import { PublisherSearchInput } from '@/components/ui/features/societies/PublisherSearchInput/PublisherSearchInput';
import { Layout } from '@/components/ui/shared/layouts/Layout/Layout';
import { AccessFrom } from '@/enums/AccessFrom';
import { ThinConferenceSort } from '@/enums/ThinConferenceSort';
import { queryThinConferencesInfinite } from '@/queries/thin-conferences';
import { generateStore } from '@/utils/generateStore';
import { Hydrate, IHydrateProps } from '@/utils/swr/Hydrate';
import { StringParam, urlQueryStringValidate } from '@/utils/url-query-string';

const Publishers: NextPage<IHydrateProps> = ({ fallback }) => {
  return (
    <Hydrate fallback={fallback}>
      <Layout accessFrom={AccessFrom.Core} navigationVariant="default">
        <PublisherSearchInput />
        <PublishersContent />
      </Layout>
    </Hydrate>
  );
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const store = generateStore({ context });
  const { query, sort, subject_subtree_of_id } = urlQueryStringValidate<{
    query: string;
    subject_subtree_of_id: Array<string>;
    sort: ThinConferenceSort;
  }>(context.query, {
    query: StringParam,
    subject_subtree_of_id: StringParam,
    sort: StringParam,
  });

  await store.fetchResourcesInfinite(
    queryThinConferencesInfinite(
      {
        query,
        subject_id: subject_subtree_of_id,
        visible: 'true',
        with_library_lectures: 'true',
      },
      sort
    )
  );

  return {
    props: {
      fallback: store.fallback,
    },
  };
};

export default Publishers;
